const translations = {
  "en": {
    "%{var0} moves toward your goal": "%{var0} moves toward your goal",
    "+ %{var0} more moves": "+ %{var0} more moves",
    "Active my plan": "Active my plan",
    "View details": "View details"
  },
  "zh-tw": {
    "%{var0} moves toward your goal": "%{var0} 正朝你的目標邁進",
    "+ %{var0} more moves": "+ %{var0} 個變動",
    "Active my plan": "啟用我的計畫",
    "View details": "查看詳情"
  }
};

export default translations;
